<template>
    <div class="authForm">
        <div class="authForm__container">
            <div class="row">
                <div class="col-lg-8 col-12 p-5">
                    <div class="authState">
                        <keep-alive>
                            <component v-bind:is="authState"></component>
                        </keep-alive>
                    </div>
                </div>
                <div class="img__container d-none d-lg-block col-lg-4">
                    <div class="img__background"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import login from "./login.vue"
import register from "./register.vue"
import { mapState } from "vuex"
import { gsap } from "gsap";

export default {
    computed: {
        ...mapState([
            "authState"
        ])
    },
    
    components: {
        login,
        register
    },

    mounted() {
        let tl = gsap.timeline();
        if(window.innerWidth < 737) {
            tl.kill()
        } else {
            tl.from(".authForm__container", {width: 0, duration: .8});
            tl.from(".img__container", {opacity: .2, duration: 1});
        }
    }
}
</script>

<style lang="scss" scoped>
    .authForm {
        background-color: rgb(159, 159, 255, .2);
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        &__container {
            background-color: white;
            width: 80%;
            height: 80%;
            box-shadow: 2px 2px 10px 1px rgba(black, .16)
        }
    }

    .img {
        &__container {
            padding: 0;
        }

        &__background {
            width: 100%;
            height: 100%;
            background: url("../assets/auth.jpg");
            background-size: cover;
            z-index: 0
        }
    }

    .row {
        height: 100%;
        margin: 0;
    }
</style>